function useUserInfo() {
  const isAdmin = document.querySelector("#admin")?.dataset?.admin === "1";
  return { isAdmin };
}
export default useUserInfo;
